import SITE_CONFIG from '../config/siteConfig'

const ensureMeta = (name, attr, value) => {
  if (!value) return
  let tag = document.querySelector(`meta[${attr}="${name}"]`)
  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute(attr, name)
    document.head.appendChild(tag)
  }
  tag.setAttribute('content', value)
}

const setCanonical = (url) => {
  if (!url) return
  let link = document.querySelector('link[rel="canonical"]')
  if (!link) {
    link = document.createElement('link')
    link.setAttribute('rel', 'canonical')
    document.head.appendChild(link)
  }
  link.setAttribute('href', url)
}

const setJsonLd = (id, json) => {
  if (!json) return
  let script = document.getElementById(id)
  if (!script) {
    script = document.createElement('script')
    script.type = 'application/ld+json'
    script.id = id
    document.head.appendChild(script)
  }
  script.textContent = JSON.stringify(json)
}

export const applySeoTags = ({
  title,
  description,
  canonical,
  ogImage,
  type = 'website',
  locale = 'en_US',
  noindex = false,
}) => {
  const resolvedTitle = title || SITE_CONFIG.defaultTitle
  const resolvedDescription = description || SITE_CONFIG.description
  const resolvedCanonical = canonical || SITE_CONFIG.domain

  document.title = resolvedTitle

  ensureMeta('description', 'name', resolvedDescription)
  ensureMeta('robots', 'name', noindex ? 'noindex, nofollow' : 'index, follow')

  // Open Graph
  ensureMeta('og:title', 'property', resolvedTitle)
  ensureMeta('og:description', 'property', resolvedDescription)
  ensureMeta('og:type', 'property', type)
  ensureMeta('og:locale', 'property', locale)
  ensureMeta('og:url', 'property', resolvedCanonical)
  ensureMeta('og:site_name', 'property', SITE_CONFIG.name)
  ensureMeta('og:image', 'property', ogImage || `${SITE_CONFIG.domain}logo192.png`)

  // Twitter
  ensureMeta('twitter:card', 'name', 'summary_large_image')
  ensureMeta('twitter:title', 'name', resolvedTitle)
  ensureMeta('twitter:description', 'name', resolvedDescription)
  ensureMeta('twitter:image', 'name', ogImage || `${SITE_CONFIG.domain}logo192.png`)

  setCanonical(resolvedCanonical)
}

export const injectOrgJsonLd = () => {
  setJsonLd('ld-org', {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SITE_CONFIG.name,
    url: SITE_CONFIG.domain,
    logo: `${SITE_CONFIG.domain}logo192.png`,
    sameAs: Object.values(SITE_CONFIG.social || {}),
  })
  setJsonLd('ld-website', {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    url: SITE_CONFIG.domain,
    name: SITE_CONFIG.name,
    potentialAction: {
      '@type': 'SearchAction',
      target: `${SITE_CONFIG.domain}search?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  })
}

export default applySeoTags

